import PropTypes from 'prop-types';
import React, {useState} from 'react';
import styled from 'styled-components';
import {scrollStyles} from 'styles/shared';
import AccordionItem from './AccordionItem';

const AccordionContainer = styled.div`
  height: ${props => `${props.height}rem`};
  overflow-y: auto;
  padding-right: 2rem;
  ${scrollStyles}
`;

Accordion.propTypes = {
  height: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  icon: PropTypes.string
};

Accordion.defaultProps = {
  icon: 'grater'
};

function Accordion({height, items, icon}) {
  const [itemSelected, setItemSelected] = useState('');

  function onSelect(id) {
    let selectedId = id && id === itemSelected ? '' : id;

    setItemSelected(selectedId);
  }

  return (
    <AccordionContainer height={height}>
      {items.map(item => {
        const id = item.id;

        let selected = id === itemSelected;

        return <AccordionItem key={id} item={item} icon={icon} selected={selected} onClick={() => onSelect(id)} />;
      })}
    </AccordionContainer>
  );
}

export default Accordion;
